import { render, staticRenderFns } from "./sekectapi.vue?vue&type=template&id=5e38e421&scoped=true&"
import script from "./sekectapi.vue?vue&type=script&lang=js&"
export * from "./sekectapi.vue?vue&type=script&lang=js&"
import style0 from "./sekectapi.vue?vue&type=style&index=0&id=5e38e421&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e38e421",
  null
  
)

export default component.exports